// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 1625px) {

    .Clarify-Ticket-Form_showHideMiniKnowledgebase__kHS8P {
        display: none;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Admin-Dashboard/Clarify-Ticket-Form.module.css"],"names":[],"mappings":"AAAA;;IAEI;QACI,aAAa;IACjB;EACF","sourcesContent":["@media only screen and (max-width: 1625px) {\n\n    .showHideMiniKnowledgebase {\n        display: none;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showHideMiniKnowledgebase": `Clarify-Ticket-Form_showHideMiniKnowledgebase__kHS8P`
};
export default ___CSS_LOADER_EXPORT___;
